import { render, staticRenderFns } from "./DesignPortfolioSuggestionsHeader.vue?vue&type=template&id=4208dbce&scoped=true&"
import script from "./DesignPortfolioSuggestionsHeader.vue?vue&type=script&lang=js&"
export * from "./DesignPortfolioSuggestionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DesignPortfolioSuggestionsHeader.vue?vue&type=style&index=0&id=4208dbce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208dbce",
  null
  
)

export default component.exports